import { forwardRef } from 'react';

import { FieldMappingTextEditor, FieldMappingTextEditorProps } from '@components/text-editors';
import { FieldMappingData } from '@components/text-editors/addons/field-mapping';
import { EditorMethods } from '@components/text-editors/text-editor';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFieldMappingTextEditorProps<T = unknown> = FormFieldProps<
  FieldMappingTextEditorProps,
  T
> &
  FieldMappingData;

export const FormFieldMappingTextEditor = forwardRef<
  EditorMethods,
  FormFieldMappingTextEditorProps<any>
>((props, ref) => {
  const formFieldProps = useFormField({ ...props, valueType: 'text-editor' });
  return <FieldMappingTextEditor ref={ref} {...props} {...formFieldProps} />;
});
